/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_EyebrowInputs */

const en_directory_resources_contact_eyebrow = /** @type {(inputs: Directory_Resources_Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Seek AI`)
};

const zh_directory_resources_contact_eyebrow = /** @type {(inputs: Directory_Resources_Contact_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系 Seek AI`)
};

/**
* | output |
* | --- |
* | "Contact Seek AI" |
*
* @param {Directory_Resources_Contact_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_eyebrow = /** @type {((inputs?: Directory_Resources_Contact_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_eyebrow(inputs)
	return zh_directory_resources_contact_eyebrow(inputs)
});
export { directory_resources_contact_eyebrow as "directory.resources.contact.eyebrow" }